<template>

  <el-main>

    <el-alert
      title="登录或注册"
      type="success"
      :closable="false"
      description="请输入手机号进行登录，如果手机号不存在会自动为你创建账号进行注册，登录后可设置密码进行密码登录"
      show-icon>
    </el-alert>
    <br>

    <el-form :model="login" status-icon :rules="rules" ref="login" label-width="100px">
      <el-form-item label="输入手机号码" prop="phone_number">
        <el-input v-model.number="login.phone_number" minlength="11" maxlength="11" show-word-limit placeholder="请输入11位手机号码（目前仅支持中国大陆手机号）"></el-input>
      </el-form-item>
      <el-form-item label="密码或验证码" prop="password_code">
        <el-input type="password" v-model="login.password_code" autocomplete="off" minlength="11" maxlength="11" placeholder="请输入6-18位密码或6位验证码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="doLogin">登录或注册</el-button>
        <el-button type="primary" @click="getSmsCode">获取验证码</el-button>
      </el-form-item>
    </el-form>

  </el-main>

</template>

<script>
export default {
  name: 'Login',
  data () {
    var phoneNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else if (!/^1[23456789]\d{9}$/.test(value)) {
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    }
    var passwordCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码或验证码'))
      } else {
        callback()
      }
    }
    return {
      login: {
        phone_number: '',
        password_code: ''
      },
      rules: {
        phone_number: [
          { validator: phoneNumber, trigger: 'blur' }
        ],
        password_code: [
          { validator: passwordCode, trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    document.title = '网湖 - 登录页面 - 网址导航|网站导航|网址大全|网站大全'
    this.$http.defaults.baseURL = process.env.VUE_APP_BASE_API
  },
  methods: {
    getSmsCode () {
      this.$refs.login.validateField('phone_number', (valid) => {
        if (valid) {
          return false
        }
        this.$http.post('auth/smsCode/get', this.login).then((response) => {
          if (response.data.code !== 0) {
            this.$message({message: '获取验证码失败', type: 'error'})
          } else {
            this.$message({message: '获取验证码成功', type: 'success'})
          }
        })
      })
    },
    doLogin () {
      this.$refs.login.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post('auth/login', this.login).then((response) => {
          if (response.data.code !== 0) {
            this.$message({message: response.data.msg, type: 'error'})
          } else {
            localStorage.clear()
            localStorage.setItem('token', response.data.data)
            window.location.href = '/'
          }
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-main {
  margin-left: 10%;
  width: 80%;
  min-height: 85vh;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue